import { Box } from "@mui/material";
import { DotSeparatedList, Text } from "@src/appV2/redesign/system/ui-components";

interface WorkplaceProfileHeadingProps {
  type: string;
  distanceText?: string;
}
export function WorkplaceProfileHeading(props: WorkplaceProfileHeadingProps) {
  const { type, distanceText } = props;

  return (
    <Box>
      <DotSeparatedList>
        <Text semibold variant="caption" color={(theme) => theme.palette.text.tertiary}>
          {type}
        </Text>

        {distanceText && (
          <Text semibold variant="caption" color={(theme) => theme.palette.text.tertiary}>
            {distanceText}
          </Text>
        )}
      </DotSeparatedList>
    </Box>
  );
}
